var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairClimbing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#F9EFE2;}\n\t.st3{fill:#B82555;}\n\t.st4{fill:#FFD881;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,149.49,62.94,183.78,105.63,183.78"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "109.83,65.63 109.83,83.18 109.83,83.18 109.83,83.18 109.83,83.18 92.27,83.18 92.27,100.74  92.27,100.74 92.27,100.74 92.27,100.74 74.72,100.74 74.72,118.29 74.72,118.29 57.17,118.29 57.17,135.84 73.32,143.43  127.38,135.84 127.38,83.18 127.38,65.63 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.98,73.21 125.98,90.77 125.98,90.77 125.98,90.77 125.98,90.77 108.42,90.77 108.42,108.32  108.42,108.32 108.42,108.32 108.42,108.32 90.87,108.32 90.87,125.87 90.87,125.87 73.32,125.87 73.32,143.43 90.87,143.43  143.53,143.43 143.53,90.77 143.53,73.21 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "127.38,65.63 143.53,73.21 125.98,73.21 109.83,65.63 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "109.83,83.14 125.98,90.72 108.42,90.72 92.27,83.14 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "92.27,100.74 108.42,108.32 90.87,108.32 74.72,100.74 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "74.67,118.34 90.82,125.92 73.27,125.92 57.12,118.34 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.85,90.09c0,0.03-0.02,0.06-0.06,0.06l0,0h-0.11c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06 h0.11C100.83,90.03,100.85,90.05,100.85,90.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairClimbing);
export default __webpack_public_path__ + "static/media/Stair_climbing.ad53b2ac8b1a34e6da22ef1817b3595d.svg";
export { ForwardRef as ReactComponent };